import { LocaleEnum as s } from "./locales.mjs";
import { S as a, a as S, b as v, c as g, d as r, e as t, f as o, g as l, h as m, i as E, j as e, k as i, l as N, m as P } from "./tr-DsWMR39f.js";
const D = {
  [s.Cs]: a,
  [s.Da]: S,
  [s.De]: v,
  [s.En]: g,
  [s.Es]: r,
  [s.Fi]: t,
  [s.Fr]: o,
  [s.It]: l,
  [s.Nb]: m,
  [s.Nl]: E,
  [s.Pl]: e,
  [s.Pt]: i,
  [s.Sv]: N,
  [s.Tr]: P
};
export {
  D as L
};
//# sourceMappingURL=LocaleIcon.const-2pFJMoZs.js.map
